import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CreditCardIcon, LeafIcon, LockKeyholeIcon, ShieldCheckIcon, StarIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './Shared';
import { DecorativeDandelions } from './DecorativeDandelions';
const productImage = 'https://cdn.magicpatterns.com/uploads/4fvjTrMnTJYKdEuyTDHEyd/1nlnl.png';
export function Hero() {
  return <section className="relative isolate overflow-hidden border-b border-brand-green/15 py-8 sm:py-12 md:py-16 pt-[20px]" data-id="element-117" data-mp="129qrndlnhbk6">
      <DecorativeDandelions className="left-[4%] top-24 hidden h-64 w-48 md:block" data-id="element-118" data-mp="xaxgvsxqzynp" />
      <DecorativeDandelions className="bottom-4 right-[3%] hidden h-56 w-40 md:block" tone="gold" data-id="element-119" data-mp="sa9n4zi4x3ps" />

      <div className="relative mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8" data-id="element-120" data-mp="nbyh6zuyndcu">
        <motion.header initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55
      }} className="mx-auto flex max-w-4xl flex-col items-center" data-id="element-121" data-mp="3d2bn1yjw7fzr">
          <div className="inline-flex items-center gap-2 rounded-full border border-brand-green/25 bg-brand-cream px-4 py-2 text-xs font-bold tracking-[.14em] text-brand-dark shadow-sm" data-id="element-122" data-mp="3o6u5h5qxajat">
            <LeafIcon className="h-4 w-4 text-brand-green" aria-hidden="true" data-id="element-123" data-mp="3e7uzxw1gf3s1" />
            LUMEN AKASHA™
          </div>

          <div className="hero-tagline mt-5 w-full px-1 text-center sm:mt-6" data-id="element-124" data-mp="30g6lhm3qg37w">
            <h1 className="hero-tagline-text mx-auto max-w-[18rem] font-[Cinzel,_serif] font-extrabold tracking-[.035em] sm:max-w-none text-[28px]" data-id="element-125" data-mp="35a2gqgsm3bzd">
              SANÁ EL ORIGEN.
              <br data-id="element-126" data-mp="2vjpxqt0g3qvc" />
              TRANSFORMÁ TU CONSULTA.
            </h1>
          </div>

          <p className="max-w-2xl font-serif font-semibold text-brand-dark sm:text-xl md:text-2xl text-[13px] mt-[10px]" data-id="element-127" data-mp="2hk84a0c7fpfn">
            La herramienta clínica que faltaba en tu consultorio
          </p>
        </motion.header>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.12
      }} className="mx-auto mt-6 w-full max-w-2xl sm:mt-8" data-id="element-128" data-mp="s3mf683jc910">
          <img src={productImage} alt="Colección Código Hepático con ebook, protocolos clínicos y guías para terapeutas" className="mx-auto max-w-[22rem] object-contain drop-shadow-[0_20px_22px_rgba(23,59,43,0.18)] sm:max-w-lg w-[324px] h-[324px]" draggable={false} data-id="element-129" data-mp="1b0nkju104b5h" />
        </motion.div>

        <p className="mx-auto mt-5 max-w-2xl font-semibold text-brand-green sm:text-base text-[13px]" data-id="element-130" data-mp="x0l5efk2vvtx">
          El protocolo, las plantas y la hoja de ruta que tus pacientes
          necesitan para avanzar solos en 21 días.
        </p>

        <div className="mx-auto mt-6 w-full max-w-3xl overflow-hidden rounded-full border border-brand-green/20 bg-brand-cream sm:mt-7" data-id="element-131" data-mp="1x9b42xkwqvaz">
          <div className="ticker-track flex w-max items-center whitespace-nowrap py-2 text-xs font-semibold text-brand-dark" data-id="element-132" data-mp="21by07aom32dz">
            {[0, 1].map(duplicate => <div key={duplicate} className="flex shrink-0 items-center gap-4 px-4" data-id="element-133" data-mp="2b0fvxdi1ajar">
                <span className="inline-flex items-center gap-1.5" data-id="element-134" data-mp="2fyr7ptrw33vm">
                  <BookOpenIcon className="h-3.5 w-3.5 text-brand-green" aria-hidden="true" data-id="element-135" data-mp="2kynaxqsrira4" />
                  100% PDF
                </span>
                <span className="h-1 w-1 rounded-full bg-brand-yellow" aria-hidden="true" data-id="element-136" data-mp="2tzbs2udgd7r8" />
                <span className="inline-flex items-center gap-1.5" data-id="element-137" data-mp="uo0svysz6ooj">
                  <ZapIcon className="h-3.5 w-3.5 text-brand-green" aria-hidden="true" data-id="element-138" data-mp="zkr9cn8ozmah" />
                  Acceso en 5 min
                </span>
                <span className="h-1 w-1 rounded-full bg-brand-yellow" aria-hidden="true" data-id="element-139" data-mp="3vigo07a1afyu" />
                <span className="inline-flex items-center gap-1.5" data-id="element-140" data-mp="e7ha9huhzuqv">
                  <LeafIcon className="h-3.5 w-3.5 text-brand-green" aria-hidden="true" data-id="element-141" data-mp="9bs8r8yx43rx" />
                  Compatible con cualquier corriente terapéutica
                </span>
                <span className="h-1 w-1 rounded-full bg-brand-yellow" aria-hidden="true" data-id="element-142" data-mp="3cp33yx7uzty0" />
              </div>)}
          </div>
        </div>

        <div className="mt-7 flex flex-col items-center gap-5 sm:mt-8" data-id="element-143" data-mp="3mnir6p3rmj28">
          <CTAButton className="max-w-full text-base md:text-lg" data-id="element-144" data-mp="2yy7x1qgx7mx2">
            🌿 → QUIERO MI CODIGO AHORA
          </CTAButton>

          <div className="mx-auto w-full max-w-3xl overflow-hidden rounded-full border border-brand-green/15 bg-brand-cream/70" data-id="element-145" data-mp="2tyvbd91sclw2">
            <div className="ticker-track flex w-max items-center whitespace-nowrap py-2 text-xs font-medium text-brand-muted" data-id="element-146" data-mp="1e9ngb92atd36">
              {[0, 1].map(duplicate => <div key={duplicate} className="flex shrink-0 items-center gap-4 px-4" data-id="element-147" data-mp="14jkf4ll0wstr">
                  <span className="inline-flex items-center gap-1.5" data-id="element-148" data-mp="1sa6n6cv12d3r">
                    <ShieldCheckIcon className="h-3.5 w-3.5 shrink-0 text-brand-green" aria-hidden="true" data-id="element-149" data-mp="1x7zu5845nb53" />
                    Garantía 7 días
                  </span>
                  <span className="h-1 w-1 rounded-full bg-brand-yellow" aria-hidden="true" data-id="element-150" data-mp="1n8qzed1gtsho" />
                  <span data-id="element-151" data-mp="bux0h8us51p6">Descarga inmediata</span>
                  <span className="h-1 w-1 rounded-full bg-brand-yellow" aria-hidden="true" data-id="element-152" data-mp="bvoifgvgf0wz" />
                  <span data-id="element-153" data-mp="29ihdbyhwkx7u">Listo para usar en consultorio</span>
                  <span className="h-1 w-1 rounded-full bg-brand-yellow" aria-hidden="true" data-id="element-154" data-mp="29j96z3rxwkvh" />
                  <span className="inline-flex items-center gap-1.5" data-id="element-155" data-mp="1zt7hq8nuowez">
                    <LockKeyholeIcon className="h-3.5 w-3.5 shrink-0 text-brand-green" aria-hidden="true" data-id="element-156" data-mp="1zqtn20x31m7y" />
                    Pago seguro
                  </span>
                  <span className="h-1 w-1 rounded-full bg-brand-yellow" aria-hidden="true" data-id="element-157" data-mp="1lsd8jnszarf9" />
                  <span className="inline-flex items-center gap-1.5" data-id="element-158" data-mp="1gvmqww1iznrq">
                    <CreditCardIcon className="h-3.5 w-3.5 shrink-0 text-brand-green" aria-hidden="true" data-id="element-159" data-mp="3g5uuj6dqjg86" />
                    Mercado Pago
                  </span>
                  <span className="h-1 w-1 rounded-full bg-brand-yellow" aria-hidden="true" data-id="element-160" data-mp="3jolfzgngyt0b" />
                </div>)}
            </div>
          </div>
        </div>
      </div>

      <div className="relative mt-9 border-y border-brand-green/15 bg-brand-cream/70 py-4 sm:mt-12" data-id="element-161" data-mp="1bdq1m5mtt0g">
        <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-x-5 gap-y-2 px-4 text-center text-xs text-brand-text sm:gap-x-6 sm:text-sm" data-id="element-162" data-mp="30qhjblorqmfe">
          <span data-id="element-163" data-mp="34te1xceb6ijc">
            <strong className="text-brand-green" data-id="element-164" data-mp="39qxfea36mra8">+500</strong> terapeutas y
            personas acompañadas
          </span>
          <span className="hidden h-1 w-1 rounded-full bg-brand-yellow sm:block" aria-hidden="true" data-id="element-165" data-mp="3eqs88j6ipqxx" />
          <span data-id="element-166" data-mp="p06ts4shx55m">
            <strong className="text-brand-green" data-id="element-167" data-mp="p2sw9q0j4ugz">1</strong> ebook principal
          </span>
          <span className="hidden h-1 w-1 rounded-full bg-brand-yellow sm:block" aria-hidden="true" data-id="element-168" data-mp="u1majknn4pi7" />
          <span data-id="element-169" data-mp="1b2ied5qysts1">
            <strong className="text-brand-green" data-id="element-170" data-mp="1b306praianuo">3</strong> bonus incluidos
          </span>
          <span className="hidden h-1 w-1 rounded-full bg-brand-yellow sm:block" aria-hidden="true" data-id="element-171" data-mp="1otn51iccubq8" />
          <span className="inline-flex items-center gap-1" data-id="element-172" data-mp="1k1c6ojx9ixzs">
            <StarIcon className="h-4 w-4 fill-brand-yellow text-brand-yellow" aria-hidden="true" data-id="element-173" data-mp="1yqrv3t9bmrcb" />
            <strong className="text-brand-green" data-id="element-174" data-mp="1ts6w1x5t2dpg">4.9/5</strong> calificación
            promedio
          </span>
        </div>
      </div>
    </section>;
}